import {type ChangeEvent, type InputHTMLAttributes, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {cn} from '../../lib/cn';
import {compressImage} from '../../lib/compression';

type DeviceCameraProps = {
  onChange: (photo?: Promise<string>) => void;
  facingMode?: InputHTMLAttributes<unknown>['capture'];
  className?: string;
};

function DeviceCamera({onChange, facingMode, className}: DeviceCameraProps) {
  const {t} = useTranslation();

  const handleNativeScreenshot = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      onChange(file ? compressImage(file) : undefined);
    },
    [onChange],
  );

  return (
    <div
      className={cn(
        'mobile-webcam-device-camera flex flex-col items-center gap-3 rounded-xl bg-[#1c1b1f] p-4 text-sm text-white',
        className,
      )}
    >
      <div>{t('camera_errors.experiencing_camera_issues')}</div>
      <label className="text-[16px] font-semibold uppercase leading-6">
        {t('open_devices_camera')}
        <input
          className="sr-only"
          type="file"
          accept="image/*"
          capture={facingMode || 'environment'}
          onChange={handleNativeScreenshot}
        />
      </label>
    </div>
  );
}

export {DeviceCamera};
